export enum CosmosChainId {
  Router = 'router_9600-1',
  Cosmoshub = 'cosmoshub-4',
  Juno = 'juno-1',
  Osmosis = 'osmosis-1',
  Terra = 'columbus-5',
  TerraUST = 'columbus-5',
  Chihuahua = 'chihuahua-1',
  Axelar = 'axelar-dojo-1',
  Evmos = 'evmos_9001-2',
  Persistence = 'core-1',
  Secret = 'secret-4',
}

export enum TestnetCosmosChainId {
  Router = 'router_9607-1',
  Cosmoshub = 'cosmoshub',
}

export enum DevnetCosmosChainId {
  Router = 'router_9603-1',
}

export enum AlphaDevnetCosmosChainId {
  Router = 'router_9625-1',
}
